module.exports = __webpack_public_path__ + "static/media/first-lithonia-medical-center-family.b109deab.jpg";